import { NodeDetailDrawer } from '../DrawingBoard/NodeDetailDrawer'
import type { ChecklistDetailController } from '../../types/checklistDetailController'
import type { ChecklistBreadcrumbSegment } from '../../utils/checklistBreadcrumb'

type Props = {
  open: boolean
  controller: ChecklistDetailController
  onClose: () => void
  presentation?: 'drawer' | 'popup' | 'inline'
  breadcrumb?: ChecklistBreadcrumbSegment[] | null
  focusedOccurrenceKey?: string | null
}

export const ChecklistDetailControllerDrawer = ({
  open,
  controller,
  onClose,
  presentation = 'drawer',
  breadcrumb = null,
  focusedOccurrenceKey = null,
}: Props) => (
  <NodeDetailDrawer
    isOpen={open && controller.status === 'ready' && Boolean(controller.item)}
    node={controller.item}
    presentation={presentation}
    boardNodes={controller.boardNodes}
    workspaceMembers={controller.workspaceMembers}
    isReadOnly={controller.isReadOnly}
    canEdit={controller.canEdit}
    canDelete={controller.canDelete}
    breadcrumb={breadcrumb}
    focusedOccurrenceKey={focusedOccurrenceKey}
    onDeleteNode={controller.deleteItem}
    onClose={onClose}
    onTitleBlur={controller.updateTitle}
    onWeightageBlur={controller.updateWeightage}
    onSaveDraft={controller.saveDraft}
    onVerificationChange={controller.updateVerification}
    onStatusChange={controller.updateStatus}
    onAssignmentChange={controller.updateAssignment}
    // Fallback permissions: when operationalAccess hasn't resolved yet,
    // default to all-true to avoid silently disabling controls.
    // The controller and backend enforce real permissions on write.
    operationalPermissions={
      controller.operationalAccess?.permissions ?? {
        assign: true,
        status: true,
        complete: true,
        proof: true,
        memo: true,
        comment: true,
        locationCheckin: true,
      }
    }
    operationalDisabledReason={controller.operationalAccess?.workDisabledReason ?? controller.notice?.message ?? null}
    completionDisabledReason={controller.operationalAccess?.completionDisabledReason ?? null}
    pendingStatus={controller.pendingStatus ?? null}
    pendingBlockers={controller.pendingBlockers ?? []}
    onPendingStatusDismiss={() => controller.setPendingStatus(null)}
    onReparent={controller.canEdit && controller.item
      ? (nextParentId, opts) => controller.updateParent(controller.item!, nextParentId, opts)
      : undefined}
    parentPickerCandidates={controller.parentCandidates}
    parentPickerWorkspaceDefaultId={controller.workspaceDefaultContainerId}
  />
)
